import React from 'react';
import Widget from './widget';
import IncomeChart from './income-chart';
import esriStrings from '../../resources/esriStrings';
import layerUrls from '../../resources/vtlayers';

const Income = (props) => {
  const [showChart, setShowChart] = React.useState(true);
  React.useEffect(() => {
    if (props.currentFeature) {
      const income = props.currentFeature.attributes.income;
      setShowChart(Boolean(income.income_high) && Boolean(income.income_low) && Boolean(income.income_midhigh) && Boolean(income.income_low));
    }
    if (props.isActive) {
      props.onUpdateLayer(layerUrls.income);
      props.setActiveLegend('income');
    }
  }, [props]);
  const handleShow = () => {
    props.onWidget(3);
  };

  return (
    <Widget
      info={props.info}
      isActive={props.isActive}
      title={esriStrings.widgetThree}
      onWidget={handleShow}
    >
      {showChart
      ? <IncomeChart
          currentFeature={props.currentFeature}
          onWidget = {handleShow}
        />
      : <div
          className="no-data-wrapper"
        >
          <h1 className="no-data">
            No Income Data Available
          </h1>
        </div>}
    </Widget>
  );
};

export default Income;
